import { HttpApiEndpoint, HttpApiError, HttpApiGroup } from "@effect/platform";
import { Schema } from "effect";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { Authorization } from "../auth/middleware";
import { ConversationId } from "../ids/definitions";
import {
  ConversationListCursor,
  ConversationListItemResponse,
  ConversationResponse,
} from "../models/shopper-ai/conversation/conversation";
import {
  MessageCursor,
  MessageResponse,
} from "../models/shopper-ai/conversation/message";
import {
  ConversationThreadCursor,
  ConversationThreadResponse,
} from "../models/shopper-ai/conversation/thread";
import {
  CursorPaginatedResponse,
  CursorPaginationParams,
} from "../schema/pagination";

export const ConversationGroup = HttpApiGroup.make("conversation")
  .add(
    HttpApiEndpoint.get("getFilteredConversations", "/conversations")
      .middleware(Authorization)
      .setUrlParams(CursorPaginationParams(ConversationListCursor))
      .addSuccess(
        CursorPaginatedResponse(
          ConversationListItemResponse,
          ConversationListCursor,
        ),
      )
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    HttpApiEndpoint.get("getConversation", "/conversations/:id")
      .middleware(Authorization)
      .setPath(Schema.Struct({ id: ConversationId }))
      .addSuccess(ConversationResponse)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    HttpApiEndpoint.get("getConversationThreads", "/conversations/:id/threads")
      .middleware(Authorization)
      .setPath(Schema.Struct({ id: ConversationId }))
      .setUrlParams(CursorPaginationParams(ConversationThreadCursor))
      .addSuccess(
        CursorPaginatedResponse(
          ConversationThreadResponse,
          ConversationThreadCursor,
        ),
      )
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    HttpApiEndpoint.get(
      "getConversationMessages",
      "/conversations/:id/messages",
    )
      .middleware(Authorization)
      .setPath(Schema.Struct({ id: ConversationId }))
      .setUrlParams(CursorPaginationParams(MessageCursor))
      .addSuccess(CursorPaginatedResponse(MessageResponse, MessageCursor))
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
